import { render } from "./DataServerSelect.vue?vue&type=template&id=38aa3775&scoped=true"
import script from "./DataServerSelect.vue?vue&type=script&lang=js"
export * from "./DataServerSelect.vue?vue&type=script&lang=js"

import "./DataServerSelect.vue?vue&type=style&index=0&id=38aa3775&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-38aa3775"

export default script